import { getParams } from './searchParams';

export type LocaleInfo = {
  locale: string;
  language: string;
  country: string;
};

const DEFAULT_LOCALE = 'en_US';
const DEFAULT_LANGUAGE = 'en';
const DEFAULT_COUNTRY = 'US';

const parseLocaleString = (
  localeString: string,
): { language: string; country: string } => {
  const parts = localeString.split('_');

  if (parts.length === 2 && parts[0] && parts[1]) {
    return {
      language: parts[0],
      country: parts[1],
    };
  }

  if (parts.length === 1 && parts[0]) {
    return {
      language: parts[0],
      country: DEFAULT_COUNTRY,
    };
  }

  return {
    language: DEFAULT_LANGUAGE,
    country: DEFAULT_COUNTRY,
  };
};

export const getLocale = (): LocaleInfo => {
  const params = getParams();
  const localeParam = params?.locale;

  if (localeParam) {
    const { language, country } = parseLocaleString(localeParam);
    return {
      locale: localeParam,
      language,
      country,
    };
  }

  return {
    locale: DEFAULT_LOCALE,
    language: DEFAULT_LANGUAGE,
    country: DEFAULT_COUNTRY,
  };
};
